/**
 * Format RFID value: allow only letters and numbers, convert letters to uppercase.
 * Strips any other characters (e.g. colons, spaces, special chars).
 */
export function formatRfid(value: string): string {
  return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase()
}
